module.exports = __webpack_public_path__ + "static/media/Caribou.svg";